module.exports = __webpack_public_path__ + "static/media/odvazni-objavitelia.209ea98f.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/exhibitors/odvazni-objavitelia.png
// module id = 512
// module chunks = 0